import React, { FC } from 'react';

import { useProjectsFilter } from '../../../../hooks';
import { Flex } from '../../../layout';
import { AlignItems } from '../../../layout/Flex/Flex';
import {
  MaturityDateSlider,
  ProjectSearchField,
  RoiSlider,
  YearProfitSlider,
} from '../../../pages/projects/filter/controls';
import ProjectFilterActive from '../../../pages/projects/filter/ProjectFilterActive';
import ProjectFilterFields from '../../../pages/projects/filter/ProjectFilterFields';
import ProjectsFilterClearAll from '../../../pages/projects/filter/ProjectsFilterClearAll';
import { Button, TertiaryButton } from '../../buttons';
import { TertiaryButtonColor } from '../../buttons/decorators/TertiaryButton/TertiaryButton';
import Modal from '../Modal';
import { ModalProps } from '../Modal/Modal';

import './ProjectsFilterModal.scoped.scss';

const ProjectsFilterModal: FC<ModalProps> = ({ active, onClose }) => {
  const projectsFilter = useProjectsFilter();

  return (
    <Modal active={active} onClose={onClose} className="projects-filter-modal">
      <header className="projects-filter-modal__header">
        <Flex alignItems={AlignItems.CENTER} gap={'1rem'}>
          <Modal.Close className="projects-filter-modal__close" />
          <div className="projects-filter-modal__heading">Фильтр</div>
        </Flex>
        <div>
          <ProjectsFilterClearAll />
        </div>
      </header>
      <main className="projects-filter-modal__main">
        <div className="projects-filter-modal__block">
          <div className="projects-filter-modal__title">Поиск</div>
          <ProjectSearchField
            value={projectsFilter.search}
            onChange={projectsFilter.setSearch}
            onSubmit={projectsFilter.handleSubmit}
          />
        </div>

        <div className="projects-filter-modal__block">
          <div className="projects-filter-modal__slider">
            <div className="projects-filter-modal__title">Срок взыскания</div>
            <MaturityDateSlider
              handleChange={projectsFilter.handleMaturityDateChange}
              currentValue={[projectsFilter.initialTermFrom, projectsFilter.initialTermTo]}
            />
          </div>
          <div className="projects-filter-modal__slider">
            <div className="projects-filter-modal__title">IRR, % годовых</div>
            <YearProfitSlider
              handleChange={projectsFilter.handleYearProfitChange}
              currentValue={[projectsFilter.interestRateFrom, projectsFilter.interestRateTo]}
            />
          </div>
          <div className="projects-filter-modal__slider">
            <div className="projects-filter-modal__title">ROI, %</div>
            <RoiSlider
              handleChange={projectsFilter.handleRoiChange}
              currentValue={[
                projectsFilter.simpleInterestRateFrom,
                projectsFilter.simpleInterestRateTo,
              ]}
            />
          </div>
        </div>

        <div className="projects-filter-modal__block projects-filter-modal__filter-clear">
          <div>
            <ProjectFilterActive>
              <ProjectFilterFields />
            </ProjectFilterActive>
          </div>
          <div>
            <TertiaryButton expanded large color={TertiaryButtonColor.GREEN}>
              <Button onClick={projectsFilter.handleSubmit}>Применить фильтр</Button>
            </TertiaryButton>
          </div>
        </div>
      </main>
    </Modal>
  );
};

export default ProjectsFilterModal;
